import translations from './const/uz.json';

const uz = {
  translation: {
    ...translations
  }
}

export default uz;